import React from 'react';

/**
 * Добавляет неразрывный пробел
 */
const Nbsp = () => <span>{'\u00A0'}</span>;

export default Nbsp;
